import { render, staticRenderFns } from "./PersonalResume.vue?vue&type=template&id=6bc049f1&scoped=true&"
import script from "./PersonalResume.vue?vue&type=script&lang=ts&"
export * from "./PersonalResume.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalResume.vue?vue&type=style&index=0&id=6bc049f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc049f1",
  null
  
)

export default component.exports